/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface HeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel {
  id: string;
  startDate: string;
  endDate?: string | null;
  title?: HeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModelTitleEnum;
  description?: string | null;
  employmentPercentage?: number;
  isManuallyEdited?: boolean;
  canManuallyEdit?: boolean;
}
export enum HeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModelTitleEnum {
  Terminated = 'Terminated',
  Dormant = 'Dormant',
  Active = 'Active',
  Other = 'Other'
}
